import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import moment from 'moment-timezone'
import VueTimeago from 'vue-timeago'
import { VueMasonryPlugin } from 'vue-masonry'
import vuescroll from 'vuescroll'
import * as Sentry from '@sentry/vue'
// load default config and extend it with tenant specific changes

import extendedConfig from './tenants.js'

Vue.config.productionTip = false

Vue.use(require('vue-moment'), {
  moment,
})
Vue.use(VueMasonryPlugin)

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
})

Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native',
      sizeStrategy: 'number',
      detectResize: true,
      zooming: false,
      scroller: {
        bouncing: {
          top: 0,
          left: 0,
          right: 100,
          bottom: 0,
        },
      },
    },
    bar: {
      background: extendedConfig.VUE_CSS_BH_BLUE,
      onlyShowBarOnScroll: false,
      keepShow: true,
    },
  },
})

Sentry.init({
  Vue,
  dsn: extendedConfig.SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  normalizeDepth: 10,
  environment: extendedConfig.SENTRY_ENV_KEY,
  enabled: process.env.NODE_ENV !== 'development',
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
